<template>
  <component :is="icon" class="w-10 h-[26px]" />
</template>

<script setup lang="ts">
import Visa from '@/assets/svg/cards/Visa.svg'
import Mastercard from '@/assets/svg/cards/Mastercard.svg'
import Amex from '@/assets/svg/cards/Amex.svg'
import Discover from '@/assets/svg/cards/Discover.svg'
import GenericCard from '@/assets/svg/cards/Generic.svg'
import { computed } from 'vue'

const props = defineProps<{
  type: string
}>()

const icon = computed(() => {
  if (props.type === 'visa') return Visa
  if (props.type === 'mastercard') return Mastercard
  if (props.type === 'discover') return Discover
  if (props.type === 'amex') return Amex
  return GenericCard
})
</script>
